import React from 'react';
import { includes } from 'lodash';
import cx from 'classnames';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/table/Table';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import WidgetItemListWrap from '../../WidgetItemListWrap';
import {
  SEARCH_HOME_MENU_LIST_TABLE_EMPTY_TEXT,
  SELECTED_SEARCH_HOME_MENU_LIST_TABLE_EMPTY_TEXT,
} from '../../../../../constants/service/app/widgetConstants';
import { columns } from './columns';
import './SearchHomeListModal.scss';

const SearchHomeListModal = (props) => {
  const {
    isOpen,
    closeModal,
    onSubmit,
    getHomeList,
    data,
    onCheckHome,
    selectedHomeIdList,
    selectedHomeList,
    openImgViewModal,
    openHomeItemListModal,
  } = props;
  const { listData } = data;
  const { list, pagination, summary = {} } = listData;

  return (
    <Modal
      title="서브 페이지 검색"
      isOpen={isOpen}
      width={760}
      height={630}
      isFooter={true}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="search-home-list-modal-wrap">
        <WidgetItemListWrap title="선택된 페이지">
          <Table
            className="selected-event-list-table"
            emptyText={SELECTED_SEARCH_HOME_MENU_LIST_TABLE_EMPTY_TEXT}
            data={selectedHomeList}
            sortable={false}
            defaultPageSize={1}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedHomeIdList}
            onCheck={(list) => onCheckHome(list)}
            columns={() =>
              columns({
                openImgViewModal,
                openHomeItemListModal,
              })
            }
          />
        </WidgetItemListWrap>

        <WidgetItemListWrap title="서브페이지 리스트">
          <TableWithSummary
            className="event-list-table"
            totalCnt={summary.totalCnt}
            emptyText={SEARCH_HOME_MENU_LIST_TABLE_EMPTY_TEXT}
            data={list}
            maxHeight={380}
            showPagination
            pagination={pagination}
            getList={getHomeList}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedHomeIdList}
            onCheck={(list) => onCheckHome(list)}
            columns={(utils) =>
              columns({
                openImgViewModal,
                openHomeItemListModal,
                ...utils,
              })
            }
            getTdProps={(state, rowInfo) => {
              return {
                className: cx({
                  selected: includes(selectedHomeIdList, rowInfo.original.id),
                }),
              };
            }}
          />
        </WidgetItemListWrap>
      </div>
    </Modal>
  );
};

export default SearchHomeListModal;
